// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sidebar_wrapper__1vjB0","store":"sidebar_store__3JtYf","name":"sidebar_name__RtXEh","fullname":"sidebar_fullname__TLU58"};